import { render } from "./AppMain.vue?vue&type=template&id=4a121daa&scoped=true&ts=true"
import script from "./AppMain.vue?vue&type=script&lang=ts"
export * from "./AppMain.vue?vue&type=script&lang=ts"

import "./AppMain.vue?vue&type=style&index=0&id=4a121daa&lang=scss&scoped=true"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a121daa"]])

export default __exports__